import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 클럽딜 서비스 운영 변경 안내 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 보러가기 > ")

import sidePng from './assets/side.png'
import sidePng2 from './assets/side@2x.png'
import sidePng3 from './assets/side@2x.png'
import angelleaguePng from './assets/ANGELLEAGUE.png'
import angelleaguePng2 from './assets/ANGELLEAGUE@2x.png'
import angelleaguePng3 from './assets/ANGELLEAGUE@3x.png'
import {AgBoxS} from '@/components/ag'
import {useInAppBrowser, provideTrackPayload} from '@/composables'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

provideTrackPayload({
  clickArea: '서비스안내배너',
})

const inAppBrowser = useInAppBrowser('https://angelleague.notion.site/a7461e43f52244378b18f9015a9018d9', '_black')

const onOpenNft = () => {
  inAppBrowser.open()
}

const gradient = 'radial-gradient(66.72% 92.71% at 44.03% 57.75%, #2A2587 20.23%, #020022 100%)'


return (_ctx: any,_cache: any) => {
  const _directive_track = _resolveDirective("track")!

  return _withDirectives((_openBlock(), _createBlock(_unref(AgBoxS), {
    css: {p: 16, background: gradient, color: 'white'},
    onClick: onOpenNft
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(AgBoxS), {
        "container-as": "img",
        css: {position: 'absolute', right: 16, top: '50%', transform: 'translateY(-50%)'},
        src: _unref(sidePng),
        srcset: `${_unref(sidePng)} 1x, ${_unref(sidePng2)} 2x, ${_unref(sidePng3)} 3x`
      }, null, 8, ["css", "src", "srcset"]),
      _createVNode(_unref(AgBoxS), {
        "container-as": "img",
        src: _unref(angelleaguePng),
        srcset: `${_unref(angelleaguePng)} 1x, ${_unref(angelleaguePng2)} 2x, ${_unref(angelleaguePng3)} 3x`,
        css: {my: 10}
      }, null, 8, ["src", "srcset"]),
      _createVNode(_unref(AgBoxS), { css: {typography: 'h5', fontWeight: 'bold', mb: 4} }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_unref(AgBoxS), { css: {typography: 'h9'} }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["css"])), [
    [_directive_track, {clickContent: '엔젤리그nft뭔가요?'}]
  ])
}
}

})